import { SxProps, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const SimpleLinkField = ({ to, value, sx = {} }: { to: string; value: string; sx?: SxProps }) => {
  return (
    <Typography
      component={RouterLink}
      to={to}
      color="primary"
      sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, ...sx }}
    >
      {value}
    </Typography>
  );
};

export default SimpleLinkField;
